export default "__VITE_ASSET__1c320230__"